import { get as idbGet, set as idbSet } from 'idb-keyval';

const localGet = (key) => {
  try {
    const v = localStorage.getItem(key);
    return v === null ? null : JSON.parse(v);
  } catch {
    return null;
  }
};

const localSet = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    /* quota or disabled storage */
  }
};

const K = {
  speaker: 'audio:speaker',
  microphone: 'audio:microphone',
  ringtone: 'audio:ringtone',
  background: 'ui:background',
  telAction: 'ui:telAction',
  autoStartCallAssistant: 'ui:autoStartCallAssistant',
};

const pinKey = (uid) => `msg:pinned:${uid}`;
const notifKey = (uid) => `notif:${uid}`;

export const saveDefaultSpeaker = (deviceId) => Promise.resolve(localSet(K.speaker, deviceId));
export const getDefaultSpeaker = () => Promise.resolve(localGet(K.speaker));

export const saveDefaultMicrophone = (deviceId) => Promise.resolve(localSet(K.microphone, deviceId));
export const getDefaultMicrophone = () => Promise.resolve(localGet(K.microphone));

export const saveDefaultRingtone = (ringtoneId) => Promise.resolve(localSet(K.ringtone, ringtoneId));
export const getDefaultRingtone = () => Promise.resolve(localGet(K.ringtone));

export const saveDefaultBackground = (backgroundId) => Promise.resolve(localSet(K.background, backgroundId));
export const getDefaultBackground = () => Promise.resolve(localGet(K.background));

export const saveDefaultTelAction = (value) => Promise.resolve(localSet(K.telAction, value));
export const getDefaultTelAction = () => Promise.resolve(localGet(K.telAction));

export const saveAutoStartCallAssistant = (value) => Promise.resolve(localSet(K.autoStartCallAssistant, value));
export const getAutoStartCallAssistant = () => Promise.resolve(localGet(K.autoStartCallAssistant));

export const setPinnedMessageSessions = (data) => idbSet(pinKey(data.uid), data.pinnedMessageSessionIds);
export const getPinnedMessageSessions = async (uid) => (await idbGet(pinKey(uid))) || [];

export const saveNotifications = (payload) => idbSet(notifKey(payload.uid), payload.data);
export const getNotifications = async (uid) => (await idbGet(notifKey(uid))) || { list: [], enabled: true };
